import mutations from './bulk/mutations';
import actions from './bulk/actions';

const bulk = {
  namespaced: true,
  state: {
    item: {
      course: null,
      tag: null,
      amount: null,
      days: null,
      codes: [],
    },
    isLoading: false,
  },
  mutations,
  actions,
};

export default bulk;
